import CopilotPanel from "@/components/CopilotPanel";
import { ShieldCheck } from "lucide-react";

export default function Copilot() {
    return (
        <div data-testid="copilot-page" className="max-w-4xl mx-auto">
            <div className="mb-6">
                <div className="eyebrow">Ask your data · VAULT Control Center</div>
                <h1 className="font-display text-4xl sm:text-5xl text-stone-900 leading-none mt-3">
                    Finance Copilot.
                </h1>
                <p className="text-sm text-stone-500 mt-4 max-w-2xl leading-relaxed">
                    A private assistant that already knows your outstanding, dues,
                    reconciliation state, and monthly spend. Ask anything.{" "}
                    <span className="inline-flex items-center gap-1 text-stone-700">
                        <ShieldCheck size={12} /> No CVV, OTP, PIN or banking passwords are ever shared.
                    </span>
                </p>
            </div>
            <div className="border border-stone-200 rounded-2xl bg-white overflow-hidden shadow-sm h-[calc(100vh-14rem)]">
                <CopilotPanel compact />
            </div>
        </div>
    );
}
